import { Request } from '../utils';

const prefix = 'pharmacy';
const userPrefix = 'pharmacy_user';
const supportPrefix = 'pharmacy_support';

// GET - Pharmacy List
export const getPharmacyList = queries => {
  const {
    limit,
    skip,
    orderBy,
    sortBy,
    name,
    city_id,
    district_id,
    is_turp_pharmacy,
    is_pharmacy_on_duty,
    min_duty_time,
    max_duty_time
  } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!name && params.append('name', name);
  !!city_id && params.append('city_id', city_id);
  !!district_id && params.append('district_id', district_id);
  !!is_turp_pharmacy && params.append('is_turp_pharmacy', is_turp_pharmacy);
  !!is_pharmacy_on_duty && params.append('is_pharmacy_on_duty', is_pharmacy_on_duty);
  !!min_duty_time && params.append('min_duty_time', min_duty_time);
  !!max_duty_time && params.append('max_duty_time', max_duty_time);

  return Request.get(`${prefix}`, { params, onlyError: true });
};

// GET -  Pharmacy detail
export const getPharmacyDetail = pharmacyId => {
  return Request.get(`${prefix}/${pharmacyId}`, { onlyError: true });
};

// GET Pharmacy Location-Coordinates
export const getPharmacyLocation = pharmacyId => {
  return Request.get(`${prefix}/${pharmacyId}/location`, { onlyError: true });
};

// POST - add Pharmacy
export const addPharmacy = values => {
  return Request.post(`${prefix}`, values, { handleNotification: true });
};

// PUT - update Pharmacy
export const updatePharmacy = (pharmacyId, values) => {
  return Request.put(`${prefix}/${pharmacyId}`, values, { handleNotification: true });
};

// PUT - update turp status
export const updateTurpStatus = (pharmacyId, value) => {
  return Request.put(
    `${prefix}/${pharmacyId}/turp_pharmacy`,
    { is_turp_pharmacy: value },
    { handleNotification: true }
  );
};

/* ------------------------------------------------ Pharmacy Users ----------------------------------------- */

// GET - Pharmacy Users list
export const getPharmacyUsersList = queries => {
  const { limit, skip, orderBy, sortBy, pharmacy_id, full_name, telephone, email } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  params.append('pharmacy_id', pharmacy_id);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!full_name && params.append('full_name', full_name);
  !!telephone && params.append('telephone', telephone);
  !!email && params.append('email', email);

  return Request.get(`${userPrefix}`, { params, onlyError: true });
};

// GET - Pharmacy User Detail
export const getPharmacyUserDetail = (pharmacyId, pharmacyUserId) => {
  return Request.get(`${userPrefix}/pharmacy/${pharmacyId}/${pharmacyUserId}`);
};

// POST - Add Pharmacy User
export const addPharmacyUser = (pharmacyId, values) => {
  return Request.post(`${userPrefix}/pharmacy/${pharmacyId}`, values, { handleNotification: true });
};

// PUT - Update Pharmacy User
export const updatePharmacyUser = (pharmacyId, pharmacyUserId, values) => {
  return Request.put(`${userPrefix}/pharmacy/${pharmacyId}/${pharmacyUserId}`, values, {
    handleNotification: true
  });
};

// PUT - Update Pharmacy User password
export const updatePharmacyUserPwd = (pharmacyId, pharmacyUserId, values) => {
  return Request.put(`${userPrefix}/pharmacy/${pharmacyId}/${pharmacyUserId}/password`, values, {
    handleNotification: true
  });
};

// DELETE - Pharmacy User
export const deletePharmacyUser = (pharmacyId, pharmacyUserId) => {
  return Request.delete(`${userPrefix}/pharmacy/${pharmacyId}/${pharmacyUserId}`, {
    handleNotification: true
  });
};

/* ------------------------------------------------- Pharmacy Support Forms ------------------------------------ */

// GET Pharmacy -  Support Forms List
export const getPharmacySupportList = queries => {
  const { limit, skip, orderBy, sortBy, pharmacy_name, subject, start_date, end_date } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!pharmacy_name && params.append('pharmacy_name', pharmacy_name);
  !!subject && params.append('subject', subject);
  !!start_date && params.append('start_date', start_date);
  !!end_date && params.append('end_date', end_date);

  return Request.get(`${supportPrefix}`, { params, onlyError: true });
};

/* GET Pharmacy - Support Form Detail  */
export const getCustomerSupportFormDetail = id => {
  return Request.get(`${supportPrefix}/${id}`, { onlyError: true });
};
